import { DatePicker, Form, Input, Select } from 'antd'

import styles from './styles.module.scss'
import { useSetupHook } from './hooks'
import Uploadfiles from '../../../../modules/uploadfiles'
import { AccountDetailRes, InvoiceParams } from '../../../../api/orderManage'
import CustomModal, { CustomModalProps } from '../../../../components/ModalUser'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../..'

export interface Props extends CustomModalProps {
  detailInfo?: AccountDetailRes
  editIndex: number
  ticketList: InvoiceParams[]
  handleSumitSuccess?: (param: InvoiceParams, editIndex: number) => void
}
export default function FinancialTicketModal(props: Props) {
  const { detailInfo, ...restProps } = props
  const {
    expressList,
    form,
    uploadFilesList,
    isLoading,
    handleUploadfilesChange,
    handleSubmit,
  } = useSetupHook(props)
  return (
    <CustomModal
      title="上传发票"
      {...restProps}
      className={styles['modal']}
      modalSubmit={handleSubmit}
      okBtnLoading={isLoading}
    >
      <Form form={form}>
        <Form.Item
          label="发票号"
          name={'invoiceNum'}
          required
          rules={[{ required: true, whitespace: true, message: '请输入' }]}
        >
          <Input placeholder="请输入"></Input>
        </Form.Item>
        <Form.Item label="发票代码" name={'invoiceCode'}>
          <Input placeholder="请输入" maxLength={20}></Input>
        </Form.Item>
        <Form.Item label="开票日期" name={'invoiceTime'}>
          <DatePicker />
        </Form.Item>
        <Form.Item
          label="含税金额"
          name={'price'}
          rules={[
            {
              pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
              message: '仅支持大于零的两位小数',
            },
          ]}
        >
          <Input placeholder="请输入"></Input>
        </Form.Item>
        <Form.Item
          label="物流公司"
          name={'logisticsCompany'}
          required
          rules={[{ required: true, message: '请输入' }]}
        >
          <Select placeholder="请选择" allowClear showSearch>
            {expressList.map((item) => {
              return (
                <Select.Option
                  value={item.expressCompany}
                  key={item.expressCode}
                >
                  {item.expressCompany}
                </Select.Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="物流单号"
          name={'logisticsNum'}
          required
          rules={[{ required: true, whitespace: true, message: '请输入' }]}
        >
          <Input placeholder="请输入" maxLength={40}></Input>
        </Form.Item>
        <Form.Item label="发票附件" name={'fileList'} required>
          <Uploadfiles
            title="选择文件"
            type="invoice"
            code={detailInfo?.id}
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            accept={FINANCIAL_INVOICE_FILE_TYPE}
            maxCount={1}
            directlyDelete
          />
          <span style={{ color: '#919191', fontSize: '12px' }}>
            支持jpg、png、jpeg、pdf
          </span>
        </Form.Item>
        <Form.Item name={'invoiceId'}>
          <Input hidden></Input>
        </Form.Item>
      </Form>
    </CustomModal>
  )
}
import { DatePicker, Form, Input, Select } from 'antd'

import styles from './styles.module.scss'
import { useSetupHook } from './hooks'
import Uploadfiles from '../../../../modules/uploadfiles'
import { AccountDetailRes, InvoiceParams } from '../../../../api/orderManage'
import CustomModal, { CustomModalProps } from '../../../../components/ModalUser'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../..'

export interface Props extends CustomModalProps {
  detailInfo?: AccountDetailRes
  editIndex: number
  ticketList: InvoiceParams[]
  handleSumitSuccess?: (param: InvoiceParams, editIndex: number) => void
}
export default function FinancialTicketModal(props: Props) {
  const { detailInfo, ...restProps } = props
  const {
    expressList,
    form,
    uploadFilesList,
    isLoading,
    handleUploadfilesChange,
    handleSubmit,
  } = useSetupHook(props)
  return (
    <CustomModal
      title="上传发票"
      {...restProps}
      className={styles['modal']}
      modalSubmit={handleSubmit}
      okBtnLoading={isLoading}
    >
      <Form form={form}>
        <Form.Item
          label="发票号"
          name={'invoiceNum'}
          required
          rules={[{ required: true, whitespace: true, message: '请输入' }]}
        >
          <Input placeholder="请输入"></Input>
        </Form.Item>
        <Form.Item label="发票代码" name={'invoiceCode'}>
          <Input placeholder="请输入" maxLength={20}></Input>
        </Form.Item>
        <Form.Item label="开票日期" name={'invoiceTime'}>
          <DatePicker />
        </Form.Item>
        <Form.Item
          label="含税金额"
          name={'price'}
          rules={[
            {
              pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
              message: '仅支持大于零的两位小数',
            },
          ]}
        >
          <Input placeholder="请输入"></Input>
        </Form.Item>
        <Form.Item
          label="物流公司"
          name={'logisticsCompany'}
          required
          rules={[{ required: true, message: '请输入' }]}
        >
          <Select placeholder="请选择" allowClear showSearch>
            {expressList.map((item) => {
              return (
                <Select.Option
                  value={item.expressCompany}
                  key={item.expressCode}
                >
                  {item.expressCompany}
                </Select.Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="物流单号"
          name={'logisticsNum'}
          required
          rules={[{ required: true, whitespace: true, message: '请输入' }]}
        >
          <Input placeholder="请输入" maxLength={40}></Input>
        </Form.Item>
        <Form.Item label="发票附件" name={'fileList'} required>
          <Uploadfiles
            title="选择文件"
            type="invoice"
            code={detailInfo?.id}
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            accept={FINANCIAL_INVOICE_FILE_TYPE}
            maxCount={1}
            directlyDelete
          />
          <span style={{ color: '#919191', fontSize: '12px' }}>
            支持jpg、png、jpeg、pdf
          </span>
        </Form.Item>
        <Form.Item name={'invoiceId'}>
          <Input hidden></Input>
        </Form.Item>
      </Form>
    </CustomModal>
  )
}
